import React from "react";
import Header from "./../components/layout/header.jsx";
import Cards1 from "./../components/elements/cards1.jsx";
import Cards2 from "./../components/elements/cards2.jsx";
import Cards3 from "./../components/elements/cards3.jsx";
import backgroundImage1 from "./../assets/img/header1.webp";
import backgroundImage2 from "./../assets/img/header2.webp";
import backgroundImage3 from "./../assets/img/header3.webp";
import imageCards1 from "./../assets/img/stocktanks.webp";
import imageCards2 from "./../assets/img/accessoires.webp";
import imageCards3 from "./../assets/img/piscine.webp";
import imageCards4 from "./../assets/img/baignoire.webp";
import imageCards5 from "./../assets/img/bainglace.webp";
import imageCards6 from "./../assets/img/bainchaud.webp";
import imageCards7 from "./../assets/img/bois.webp";
import imageCards8 from "./../assets/img/urbain.webp";
import imageCards9 from "./../assets/img/apero.webp";
import imageCards10 from "./../assets/img/jeuxenfant.webp";

const Home = () => {
  const cardData = [
    { title: "Stock de Bois", subtitle: "Chauffe ta maison", image: imageCards7, colSpan: 1, rowSpan: 2, col: 1, row: 1 },
    { title: "Décoration Urbaine", subtitle: "Pot pour fleur ou arbre", image: imageCards8, colSpan: 1, rowSpan: 1, col: 2, row: 1 },
    { title: "Stock de Boissons", subtitle: "Pause Rafraichissante", image: imageCards9, colSpan: 1, rowSpan: 1, col: 3, row: 1 },
    { title: "Jeux Enfant", subtitle: "Divertissement", image: imageCards10, colSpan: 2, rowSpan: 1, col: 2, row: 2 },
  ];

  return (
    <div>
      <Header
        backgroundImages={[backgroundImage1, backgroundImage2, backgroundImage3]}
        title="O Tank Pool"
        subtitle="la baignade réinventée"
        buttonON="true"
      />

      <div id="first-section" className="h-full bg-[#ffffff] flex flex-col items-center pt-32 pb-32 text-center px-6 xl:px-20">
        <h1 className="font-customFont2 text-5xl font-extrabold text-transparent bg-clip-text bg-[#13455a] xl:text-6xl">Nos Stocks Tanks</h1>
        <h3 className="text-[#13455a] my-14 mx-12 sm:mx-20 md:mx-40 min915:mx-52 lg:mx-64 min1130:mx-72 xl:mx-24 2xl:mx-72 xl:text-lg">Les Stock Tanks sont des réservoirs en acier galvanisé. Disponibles en forme ronde ou ovale et dans toutes les tailles. Nos Stock sont tendance et écologiques. Ils peuvent être utilisés comme piscine, spa, douche ou bassin à poissons.</h3>
        <div className="flex flex-col xl:flex-row justify-center items-center space-y-10 xl:space-y-0 xl:space-x-20">
          <Cards1 image={imageCards1} title="Stock Tanks" subtitle="Ronds et Ovales" link="tankkd" />
          <Cards1 image={imageCards2} title="Accessoires" subtitle="Complémentaires" link="accessoires" />
        </div>
      </div>

      <div className="h-full bg-[#005478] flex flex-col items-center pt-32 pb-32 text-center px-6 xl:px-20">
        <h1 className="font-customFont2 text-5xl font-extrabold text-transparent bg-clip-text bg-[#ffffff] xl:text-6xl">Les Utilisations</h1>
        <h3 className="text-base text-[#ffffff] my-14 mx-12 sm:mx-20 md:mx-40 min915:mx-52 lg:mx-64 min1130:mx-72 xl:mx-24 2xl:mx-72 xl:text-lg">Les Stock Tanks débarquent en France! Disponible dans toutes les tailles, nos Stock Tanks sont non seulement beaux mais aussi durables.</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10">
          <Cards2 image={imageCards3} title="Piscine" subtitle="Ronds et Ovales" url="BasicPack" />
          <Cards2 image={imageCards4} title="Baignoire" subtitle="Salle de Bain Atypique" url="BaignoirePack" />
          <Cards2 image={imageCards5} title="Bain Glacé" subtitle="Meilleure Récupération" url="IcePack" />
          <Cards2 image={imageCards6} title="Bain Chaud" subtitle="Soirée d'Hiver" url="HotTubPack" />
        </div>
      </div>

      <div className="h-full bg-[#ffffff] flex flex-col items-center pt-32 pb-32 text-center px-6 xl:px-20">
        <h1 className="font-customFont2 text-5xl font-extrabold text-transparent bg-clip-text bg-[#13455a] xl:text-6xl">Votre Imagination</h1>
        <h3 className="text-[#13455a] my-14 mx-12 sm:mx-24 lg:mx-52 min1310:mx-60 min1630:mx-72 min1850:mx-96 xl:text-lg">Laissez place à votre imagination ! Les Stock Tanks s'intègrent parfaitement et vous permettent de réaliser toutes vos idées d'aménagement. Alors, n'attendez plus et lancez-vous !</h3>
        <Cards3 cards={cardData} />
      </div>
    </div>
  );
};

export default Home;
